// @flow strict

const disallowedProps = [
  // Default
  'onClick',
  'className',
  'style',
  // Extra Box props
  'dangerouslySetInlineStyle',
  'xs',
  'sm',
  'md',
  'lg',
  'display',
  'column',
  'direction',
  'smDisplay',
  'smColumn',
  'smDirection',
  'mdDisplay',
  'mdColumn',
  'mdDirection',
  'lgDisplay',
  'lgColumn',
  'lgDirection',
  'bottom',
  'borderSize',
  'color',
  'left',
  'margin',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'marginStart',
  'marginEnd',
  'smMargin',
  'smMarginTop',
  'smMarginRight',
  'smMarginBottom',
  'smMarginLeft',
  'smMarginStart',
  'smMarginEnd',
  'mdMargin',
  'mdMarginTop',
  'mdMarginRight',
  'mdMarginBottom',
  'mdMarginLeft',
  'mdMarginStart',
  'mdMarginEnd',
  'lgMargin',
  'lgMarginTop',
  'lgMarginRight',
  'lgMarginBottom',
  'lgMarginLeft',
  'lgMarginStart',
  'lgMarginEnd',
  'opacity',
  'padding',
  'smPadding',
  'mdPadding',
  'lgPadding',
  'paddingX',
  'smPaddingX',
  'mdPaddingX',
  'lgPaddingX',
  'paddingY',
  'smPaddingY',
  'mdPaddingY',
  'lgPaddingY',
  'position',
  'right',
  'rounding',
  'top',
  'userSelect',
  'role',
  'zIndex',
];

export default disallowedProps;
